/**
 * PresenceAvatars — a compact strip of one avatar per connected remote peer.
 *
 * Each avatar shows the peer's initial on its stable color (the same color used
 * for the peer's cursor) with the full name as a tooltip. Renders nothing when
 * there are no remote peers, so it is inert in single-user / collab-off mode.
 */
import type { PresencePeer } from '../../collab/presence'

export interface PresenceAvatarsProps {
  peers: PresencePeer[]
}

export default function PresenceAvatars({ peers }: PresenceAvatarsProps) {
  if (peers.length === 0) return null

  return (
    <div
      data-presence-avatars
      style={{ display: 'flex', gap: 4, alignItems: 'center' }}
    >
      {peers.map((p) => (
        <div
          key={p.clientId}
          data-presence-avatar
          title={p.name}
          style={{
            width: 24,
            height: 24,
            borderRadius: '50%',
            background: p.color,
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 12,
            fontWeight: 600,
            boxShadow: '0 0 0 2px #fff',
            userSelect: 'none',
          }}
        >
          {p.name.charAt(0).toUpperCase()}
        </div>
      ))}
    </div>
  )
}
